<template>
  <div class="chat-report">
    <div class="chat-select">
      <ChatSelect :label="label" :value="value" @input="onInput" :placeholder="placeholder" :columns="columns"/>
    </div>
    <template v-if="!!currentReport">
      <div class="report-details">
        <ReportDetailsCard :title="currentReport.title" :content="currentReport.content" />
      </div>
    </template>
  </div>
</template>

<script>
import ChatSelect from "../ChatSelect/index.vue";
import ReportDetailsCard from "./ReportDetailsCard";
export default {
  components: {
    ChatSelect,
    ReportDetailsCard
  },
  computed: {
    currentReport () {
      return this.columns[this.value]
    }
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      default: '选择自动化思维报告'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    columns: {
      type: Array
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value, this.currentReport)
    }
  }
}

</script>

<style scoped lang="scss">
.chat-select {
  margin-bottom: 7px;
}
.report-details {
  padding: 25px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 1);
}
</style>